import { FJYoutube, FJGoogleDrive, FJTikTok, FJInstagram, FJLinkedin } from 'fj-social-media-library';
import FJConfig from '@src/config/FJConfig.ts';
import FJUtil from '@src/util/FJUtil';
import FJS3NetworkManager from './FJS3NetworkManager';
import FJS3Config from '@src/config/FJS3Config';

const CLIENTS = {
    youtube: FJYoutube,
    googleDrive: FJGoogleDrive,
    tiktok: FJTikTok,
    instagram: FJInstagram,
    linkedin: FJLinkedin,
};

FJTikTok.config({
    createUploadURL: `${FJConfig.RESOURCE_SERVER}/gs/tiktok/get-tiktok-upload-url`,
});

let FJShareStore = {
    /**
     * @desc 分享到社交平台
     * @param target - 分享的平台
     * @param file - 分享的文件
     * @param options - 可扩展的参数集合
     * @param options.name - 分享的视频名字
     * @param options.tags - 分享的视频的标签
     * @return {Promise<unknown>}
     * @private
     */
    _shareToTarget: function (target, file, options) {
        return new Promise((resolve, reject) => {
            let __shareSuccess = (target, response) => {
                resolve(response);
            };
            let __shareFail = e => {
                reject(e);
            };
            let {
                shareName = 'undefined', // shareName就是title
                tags = ['FlexClip'],
                title = '',
                description = '',
                privacyState, // 只有youtube会用到,设置分享的隐私权限 public or private
            } = options;

            let uploadOptions;
            switch (target) {
                case 'youtube':
                    uploadOptions = { tags: tags, title: title, description: description, privacyStatus: privacyState };
                    break;
                case 'googleDrive':
                    uploadOptions = {
                        tags: tags,
                        description: description,
                        folderId: options.folder ? options.folder.folderId : '',
                    };
                    break;
                case 'oneDrive':
                    uploadOptions = {
                        tags: tags,
                        description: description,
                        folderId: options.folder ? options.folder.folderId : 'root',
                    };
                    break;
                case 'tiktok':
                    uploadOptions = { tags: tags };
                    break;
                case 'linkedin':
                    uploadOptions = {
                        uploadType: 'video',
                        description: description,
                        uploadToS3: this.uploadLinkedinVideoToS3Async,
                    };
                    break;
                default:
                    break;
            }
            if (uploadOptions) {
                CLIENTS[target]
                    .uploadFile(file, shareName, uploadOptions)
                    .then(response => __shareSuccess(target, response))
                    .catch(__shareFail);
            }
        });
    },
    //****************** authentication | share | stop *********************************/
    uploadLinkedinVideoToS3Async: async file => {
        try {
            const key = await FJUtil.hashEncode(file);
            const dataKey = new Date().toLocaleDateString('sv-SE');
            const uploadKey = 'share/linkedin/' + dataKey + '/' + key;
            await FJS3NetworkManager.uploadFileAsync(file, uploadKey);
            const url = FJS3Config.S3_SERVER_HOST + uploadKey;
            return url;
        } catch (error) {
            console.error('uploadLinkedinVideoToS3 error', error);
            return null;
        }
    },
    stopShareToSocial: function (target) {
        if (CLIENTS[target] && CLIENTS[target].cancelUpload) CLIENTS[target].cancelUpload();
    },
    startShareToSocial: function (blob, target, options = {}) {
        if (!blob) return Promise.resolve();
        // let exportSize = FJExportStore.getExportSize();
        if (target === 'tiktok') {
            // tiktok上传限制
            // 时长600s
            // if (exportDuration > 600) {
            //     return Promise.reject({ errorDescription: 'limit' });
            // }
        }
        return this._shareToTarget(target, blob, options);
    },
    authentication: function (target) {
        if (CLIENTS[target] && CLIENTS[target].authentication) {
            return CLIENTS[target].authentication();
        } else return Promise.reject('no target');
    },

    /**
     * @desc 检查accessToken是否有效，并返回有效的数据
     * @param shareType
     * @return {Promise<never>|*|Promise<unknown>} - {access_token: '', access_data: {}}
     */
    checkAccessToken: function (shareType) {
        if (CLIENTS[shareType] && CLIENTS[shareType].getAvailableAccessToken) {
            return CLIENTS[shareType].getAvailableAccessToken();
        } else return Promise.reject();
    },
};

export default FJShareStore;
